import React, { useState, useEffect, useCallback } from 'react';
import logo from './logo.svg';
import './App.css';
import { TestComponent } from '../components/TestComponent';
import { TestClassComponent } from '../components/TestClassComponent';
import { FcFllowComponent } from '../components/FCFllowComponent';
import { UseCallBackTest } from '../components/UseCallbackTest';
import { UseRefTest } from '../components/UseRefTest';
import { AppProvider } from '../provider/AppProvider';
import { OtherProvider } from '../provider/OtherProvider';
import { OtherComp } from '../components/OtherComp';
function App() {

  const [count, setCount] = useState(0);
  const [isShowTest, setIsShowTest] = useState(true);
  const [chosedName, setChosedName] = useState('Saab');

  const countCallBack = useCallback(() => {
    let num = 0;
    //setCount(count+1);
    alert(`useCallback count:${count},${num++}`);
  }, [count]);

  const childCallback = () => {
    //setCount(count+1);
    alert(`childCallback:${count}`);
  }
  useEffect(() => {
    console.log(`app effect${count}`);
    return () => {
      console.log(`app effect return${count}`);
    }
  },[count]);
  return (
    <div className="App">
      <header className="App-header">
        {/* <img src={logo} className="App-logo" alt="logo" /> 
        <p>
          Edit <code>src/App.tsx</code> and save to reload.
        </p>*/}
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
        <select aria-label='chosedName' value={chosedName} onChange={(e) => setChosedName(e.target.value)} >
          <option value="volvo">Volvo</option>
          <option value="saab">Saab</option>
          <option value="mercedes">Mercedes</option>
          <option value="audi">Audi</option></select>
        <p>{count}</p>
        <button onClick={() => setCount(count + 1)}>+加1</button>
        <button onClick={() => setIsShowTest(!isShowTest)}>渲染&移除组件</button>
        <p>TestClassComponent</p>
          <hr/>
          <TestClassComponent
            user={chosedName} />
        <AppProvider>
          
          <p>FcFllowComponent</p>
          <hr/>
          <FcFllowComponent user={chosedName} />
        
        <hr />
        <UseCallBackTest
          parentCallBack={countCallBack}
          childCallback={childCallback} 
          /*直接将父组件中的方法传给子组件，当count变化的时候，父组件会重新渲染，
          然后childCallback会重新生成，从而造成子组件也会重新渲染，而parentCallBack采用的useCallback缓存了的，
          就不会造成子组件重渲染*/
        />
        </AppProvider>
        <hr />
        <UseRefTest/>
        <hr />
        {isShowTest ?
          <TestComponent
            testName='hello zhang'
            age={100} /> : 'noComponents'
        }
         <OtherProvider>
          <OtherComp address='深圳'/>
        </OtherProvider>
      </header>
      <hr />
      <div className='beian'> 
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer">粤ICP备16014574号-2</a>
      </div>
    </div>
  );
}

export default App;
